






































































import { Component, mixins, Prop, Vue, Watch } from 'nuxt-property-decorator'
// eslint-disable-next-line import/no-named-as-default
import Swiper from 'swiper'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import Vue2TouchEvents from 'vue2-touch-events'
import 'swiper/swiper.scss'
import chunk from 'lodash/chunk'
import MixinGeneral from '~/assets/mixins/general'
import { runIdle } from '~/assets/functions/runIdle'
Vue.use(Vue2TouchEvents)
@Component({
  components: {
    ComponentButtonIcon: () => import('~/components/form/button-icon.vue'),
    ComponentProductItem: () =>
      import('~/components/products/product-item-1.vue'),
    ComponentLoadingSpinner: () => import('~/components/loading/spinner.vue'),
  },
})
export default class ComponentCommonSlider extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] }) readonly items!: never[]
  @Prop({ type: Boolean, default: false }) private loading!: boolean
  @Prop({ type: Number, default: 1 }) private perPage!: number
  @Prop({ type: Number, default: 6 }) private slidesPerView!: number
  @Prop({ type: Number, default: 6 }) private itemsInSlide!: number
  @Prop({ type: Boolean, default: false }) private autoPlay!: boolean
  @Prop({ type: Number, default: 1500 }) private autoPlayDelay!: number
  @Prop({ type: [Object, Array, String], default: '' })
  private classSwiperWrapper!: any

  private get itemsAsSlides() {
    return chunk(this.items, this.itemsInSlide)
  }

  private get pages() {
    return this.itemsAsSlides.length
  }

  updateSliderState() {
    this.isBeginning = this.swiper.isBeginning
    this.isEnd = this.swiper.isEnd
    this.activeIndex = this.swiper.activeIndex
  }

  @Watch('items')
  private itemsHandler() {
    this.$nextTick(function () {
      this.swiper.update()
      this.updateSliderState()
    })
  }

  @Watch('slidesPerView')
  private slidesPerViewHandler() {
    this.iniSlider()
  }

  private icons = {
    mdiChevronRight,
    mdiChevronLeft,
  }

  private swiper!: Swiper

  private mounted() {
    runIdle(() => this.iniSlider())
  }

  private iniSlider() {
    if (this.swiper) {
      this.swiper.destroy()
    }

    const slideContainer: HTMLElement = this.$refs.slideContainer as HTMLElement
    if (slideContainer) {
      this.swiper = new Swiper(slideContainer, {
        direction: 'horizontal',
        slidesPerView: this.slidesPerView,
        spaceBetween: !this.$device.isMobileOrTablet ? 24 : 12,
        watchSlidesVisibility: true,
        allowTouchMove: this.$device.isMobileOrTablet,
        freeMode: this.$device.isMobileOrTablet,
        autoplay: true,
      })
      this.swiper.slideTo(0)
      this.isBeginning = this.swiper.isBeginning
      this.isEnd = this.swiper.isEnd
      this.activeIndex = this.swiper.activeIndex
      if (this.autoPlay) this.startAutoplay()
      this.$emit('loaded')
    }
  }

  public isBeginning = false
  public isEnd = false
  public activeIndex = 0

  @Watch('isEnd')
  private isEndHandler(val: boolean) {
    if (val) {
      this.$emit('isEnd')
      if (this.autoPlay) this.swiper.slideTo(1, 100)
    }
  }

  @Watch('activeIndex')
  private activeIndexHandler(val: number) {
    if (this.items.length - 1 - val <= this.perPage * 2) {
      this.$emit('loadInAdvance')
    }
  }

  private slidePrev() {
    if (!this.swiper.isBeginning) {
      this.swiper.slidePrev()
    }
    this.isBeginning = this.swiper.isBeginning
    this.isEnd = this.swiper.isEnd
    this.activeIndex = this.swiper.activeIndex
  }

  private slideNext() {
    if (!this.swiper.isEnd) {
      this.swiper.slideNext()
    } else if (this.autoPlay)
      setTimeout(() => this.swiper.slideTo(0), this.autoPlayDelay)
    this.isBeginning = this.swiper.isBeginning
    this.isEnd = this.swiper.isEnd
    this.activeIndex = this.swiper.activeIndex
  }

  private onSwipeMobile() {
    if (this.$device.isMobileOrTablet && this.swiper) {
      this.isBeginning = this.swiper.isBeginning
      this.isEnd = this.swiper.isEnd
      this.activeIndex = this.swiper.activeIndex
    }
  }

  private timer: number | null = null
  private startAutoplay() {
    if (this.autoPlay) {
      this.timer = window.setInterval(() => {
        this.slideNext()
      }, this.autoPlayDelay)
    }
  }

  private stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  public get showNavigation() {
    return !this.$device.isMobileOrTablet && this.pages > 1
  }

  private destroyed() {
    if (this.swiper) {
      this.swiper.destroy()
      this.stopAutoplay()
    }
    if (this.timer) clearInterval(this.timer)
  }
}
